(function () {
  if (window.jpcrop1Preview) return;

  /* jpcrop1 preview on the real product photos. Coordinates are in the 1254px variant photo.
     h: bar face rect (jump rings kept on top). v: face rect below the hole, top0..face top is the bar
     top around the hole (cleaned, not engraved).
     b: curved bracelet plate, top and bottom edges as polylines, zx = engraving span between the slots.
     The engraving fills the whole face or plate. Unknown variant photo: core falls back to a drawn bar. */
  var CAL = {
    '28518931562548': { t: 'h', face: [272, 868, 982, 991], keep: [[268, 854, 309, 905], [945, 854, 986, 905]], samp: [420, 830], view: [150, 640, 950, 430] },
    '28520936505396': { t: 'h', face: [273, 873, 980, 990], keep: [[268, 856, 309, 907], [944, 856, 985, 907]], samp: [420, 830], q: 0.9, gray: 1, view: [150, 640, 950, 430] },
    '28601506463796': { t: 'b', x: [337, 843], top: [[337, 861], [400, 856], [500, 854], [620, 854], [750, 858], [843, 865]], bot: [[337, 968], [843, 972]], base: [338, 352], zc: 590, zx: [327, 841], view: [110, 560, 1040, 460] },
    '28601500336180': { t: 'b', x: [337, 843], top: [[337, 862], [400, 857], [500, 854], [620, 855], [750, 859], [843, 865]], bot: [[337, 968], [843, 972]], base: [338, 352], zc: 590, zx: [327, 841], view: [110, 560, 1040, 460] },
    '28601511313460': { t: 'b', x: [337, 843], top: [[337, 855], [400, 851], [500, 848], [620, 848], [750, 852], [843, 859]], bot: [[337, 963], [843, 967]], base: [338, 352], zc: 590, zx: [327, 841], view: [110, 560, 1040, 460] },
    '25758623662132': { t: 'v', face: [551, 733, 663, 1082], top0: 701, hole: [604, 717, 18], gray: 2, view: [455, 585, 300, 520] },
    '25758606721076': { t: 'v', face: [551, 733, 663, 1082], top0: 701, hole: [604, 717, 18], gray: 1, view: [455, 585, 300, 520] }
  };

  function lerpPts(pts, x) {
    if (x <= pts[0][0]) return pts[0][1];
    for (var i = 1; i < pts.length; i++) {
      if (x <= pts[i][0]) {
        var a = pts[i - 1], b = pts[i];
        return a[1] + (b[1] - a[1]) * (x - a[0]) / (b[0] - a[0]);
      }
    }
    return pts[pts.length - 1][1];
  }

  function lum(p, i) { return 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]; }

  // pick the colour at a luminance percentile from a list of [r,g,b]
  function pct(list, q) {
    if (!list.length) return [200, 180, 140];
    list.sort(function (a, b) { return (a[0] * 299 + a[1] * 587 + a[2] * 114) - (b[0] * 299 + b[1] * 587 + b[2] * 114); });
    return list[Math.min(list.length - 1, Math.floor(list.length * q))];
  }

  var imgCache = {}, baseCache = {}, ringCache = {};
  function loadImg(url) {
    if (imgCache[url]) return imgCache[url];
    imgCache[url] = new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = url;
    });
    return imgCache[url];
  }

  // the product photo with the sample engraving wiped, so the customer's crop sits on clean metal
  function cleanBase(key, cal, im) {
    if (baseCache[key]) return baseCache[key];
    var c = document.createElement('canvas');
    c.width = im.naturalWidth; c.height = im.naturalHeight;
    var g = c.getContext('2d');
    g.drawImage(im, 0, 0);
    var x0, y0, x1, y1, d, p, w, x, y, i, row, col, colr;
    try {
      if (cal.t === 'h') {
        x0 = cal.face[0]; y0 = cal.face[1]; x1 = cal.face[2]; y1 = cal.face[3];
        w = x1 - x0;
        d = g.getImageData(x0, y0, w, y1 - y0); p = d.data;
        var rows = [], sm = [];
        for (y = 0; y < y1 - y0; y++) {
          row = [];
          for (x = cal.samp[0] - x0; x < cal.samp[1] - x0; x += 2) { i = (y * w + x) * 4; row.push([p[i], p[i + 1], p[i + 2]]); }
          rows.push(pct(row, cal.q || 0.8));
        }
        // average over nine rows so the plain metal has no banding
        for (y = 0; y < rows.length; y++) {
          var s0 = 0, s1 = 0, s2 = 0, nn = 0;
          for (var kk = -4; kk <= 4; kk++) { var rw = rows[y + kk]; if (rw) { s0 += rw[0]; s1 += rw[1]; s2 += rw[2]; nn++; } }
          sm.push([s0 / nn, s1 / nn, s2 / nn]);
        }
        for (y = 0; y < y1 - y0; y++) {
          colr = sm[y];
          for (x = 0; x < w; x++) {
            i = (y * w + x) * 4;
            var ax = x + x0, ay = y + y0, kept = false;
            for (var k = 0; k < cal.keep.length; k++) {
              var kb = cal.keep[k];
              if (ax >= kb[0] && ax <= kb[2] && ay >= kb[1] && ay <= kb[3] && lum(p, i) > 90) { kept = true; break; }
            }
            if (!kept) { p[i] = colr[0]; p[i + 1] = colr[1]; p[i + 2] = colr[2]; p[i + 3] = 255; }
          }
        }
        g.putImageData(d, x0, y0);
      } else if (cal.t === 'v') {
        x0 = cal.face[0]; y0 = cal.top0 || cal.face[1]; x1 = cal.face[2]; y1 = cal.face[3];
        w = x1 - x0;
        var fy0 = cal.face[1] - y0, ho = cal.hole;
        d = g.getImageData(x0, y0, w, y1 - y0); p = d.data;
        // light percentile per column, then smoothed across columns so the sample print leaves no stripes
        var cols = [], sm, n2, a2;
        for (x = 0; x < w; x++) {
          col = [];
          for (y = fy0 + 8; y < y1 - y0 - 8; y += 2) { i = (y * w + x) * 4; col.push([p[i], p[i + 1], p[i + 2]]); }
          cols.push(pct(col, 0.85));
        }
        for (x = 0; x < w; x++) {
          if (x < 2 || x >= w - 2) { colr = cols[x]; }
          else {
            sm = [0, 0, 0]; n2 = 0;
            for (a2 = Math.max(4, x - 12); a2 <= Math.min(w - 5, x + 12); a2++) { sm[0] += cols[a2][0]; sm[1] += cols[a2][1]; sm[2] += cols[a2][2]; n2++; }
            colr = [sm[0] / n2, sm[1] / n2, sm[2] / n2];
          }
          for (y = 0; y < y1 - y0; y++) {
            if (ho && y < fy0 && Math.hypot(x + x0 - ho[0], y + y0 - ho[1]) < ho[2]) continue;
            i = (y * w + x) * 4; p[i] = colr[0]; p[i + 1] = colr[1]; p[i + 2] = colr[2]; p[i + 3] = 255;
          }
        }
        g.putImageData(d, x0, y0);
      } else {
        // bracelet: vertical metal profile sampled from the clean plate next to the left slot
        x0 = cal.x[0]; x1 = cal.x[1];
        y0 = Math.floor(Math.min(lerpPts(cal.top, x0), lerpPts(cal.top, 500), lerpPts(cal.top, x1))) - 2;
        y1 = Math.ceil(Math.max(lerpPts(cal.bot, x0), lerpPts(cal.bot, x1))) + 2;
        w = x1 - x0;
        d = g.getImageData(x0, y0, w, y1 - y0); p = d.data;
        var N = 48, prof = [];
        for (var n = 0; n < N; n++) {
          var bin = [];
          for (x = cal.base[0]; x <= cal.base[1]; x++) {
            var t0 = lerpPts(cal.top, x) + 3, b0 = lerpPts(cal.bot, x) - 1;
            y = Math.round(t0 + (b0 - t0) * n / (N - 1)) - y0;
            i = (y * w + (x - x0)) * 4;
            bin.push([p[i], p[i + 1], p[i + 2]]);
          }
          prof.push(pct(bin, 0.5));
        }
        for (x = 0; x < w; x++) {
          var tt = lerpPts(cal.top, x + x0) + 3, bb = lerpPts(cal.bot, x + x0) - 1;
          for (y = Math.ceil(tt); y <= Math.floor(bb); y++) {
            var f = (y - tt) / (bb - tt);
            colr = prof[Math.max(0, Math.min(N - 1, Math.round(f * (N - 1))))];
            i = ((y - y0) * w + x) * 4;
            p[i] = colr[0]; p[i + 1] = colr[1]; p[i + 2] = colr[2]; p[i + 3] = 255;
          }
        }
        g.putImageData(d, x0, y0);
      }
    } catch (e) { return null; }
    try {
      // vertical and silver photos carry the sample print's cast: repaint as clean silver (1) or gold (2)
      if (cal.gray && cal.face) {
        var fx = cal.face[0], fy = cal.top0 || cal.face[1], fw = cal.face[2] - fx, fh = cal.face[3] - fy, ho2 = cal.hole;
        var dd = g.getImageData(fx, fy, fw, fh), pp = dd.data;
        for (i = 0; i < pp.length; i += 4) {
          if (ho2 && Math.hypot(fx + (i / 4) % fw - ho2[0], fy + Math.floor(i / 4 / fw) - ho2[1]) < ho2[2]) continue;
          var gl = Math.min(250, lum(pp, i) * 1.2 + 14);
          if (cal.gray === 2) { pp[i] = Math.min(255, gl * 1.04); pp[i + 1] = gl * 0.86; pp[i + 2] = gl * 0.56; }
          else { pp[i] = gl; pp[i + 1] = gl; pp[i + 2] = Math.min(255, gl * 1.02); }
        }
        g.putImageData(dd, fx, fy);
      }
      // the bright ring and hole pixels from the original photo, redrawn above the engraving
      if (cal.keep) {
        var r = document.createElement('canvas'); r.width = c.width; r.height = c.height;
        var rg = r.getContext('2d'), o2 = document.createElement('canvas'); o2.width = c.width; o2.height = c.height;
        var og = o2.getContext('2d'); og.drawImage(im, 0, 0);
        for (var kq = 0; kq < cal.keep.length; kq++) {
          var kb2 = cal.keep[kq], kw = kb2[2] - kb2[0], kh = kb2[3] - kb2[1];
          var kd = og.getImageData(kb2[0], kb2[1], kw, kh), kp = kd.data;
          for (i = 0; i < kp.length; i += 4) if (lum(kp, i) <= 90) kp[i + 3] = 0;
          rg.putImageData(kd, kb2[0], kb2[1]);
        }
        ringCache[key] = r;
      }
    } catch (e2) {}
    baseCache[key] = c;
    return c;
  }

  // the photo covers the whole engraving surface at its own proportions (never stretched).
  // The editor frames each piece at its plate shape, so the cover trims next to nothing.
  function fillStrip(crop, ZL, ZT) {
    var W = Math.max(2, Math.round(ZL)), H = Math.max(2, Math.round(ZT));
    var o = document.createElement('canvas'); o.width = W; o.height = H;
    var g = o.getContext('2d');
    g.imageSmoothingQuality = 'high';
    var E = crop.width / crop.height, Td = Math.max(H, W / E), Ld = Td * E;
    g.drawImage(crop, (W - Ld) / 2, (H - Td) / 2, Ld, Td);
    return o;
  }

  // rich engraving tones: metal gets a deep etch (multiplied onto the metal), black plating gets a
  // crisp positive print. Levels are stretched so the lashes and irises come out dark and clear.
  function inkify(c, light, warm) {
    var g = c.getContext('2d');
    try {
      var d = g.getImageData(0, 0, c.width, c.height), p = d.data, i, l, n = p.length / 4, hist = [];
      for (l = 0; l < 256; l++) hist.push(0);
      for (i = 0; i < p.length; i += 4) { l = Math.round(0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]); p[i] = l; hist[l]++; }
      var acc = 0, lo = 0, hi = 255, qlo = 0.015, qhi = light ? 0.99 : 0.9;
      for (l = 0; l < 256; l++) { acc += hist[l]; if (acc < n * qlo) lo = l; if (acc < n * qhi) hi = l; }
      if (hi - lo < 40) hi = lo + 40;
      for (i = 0; i < p.length; i += 4) {
        l = (p[i] - lo) / (hi - lo); l = l < 0 ? 0 : l > 1 ? 1 : l;
        if (light) { l = l * l * (3 - 2 * l) * 0.5 + l * 0.5; l = 14 + l * 226; p[i] = p[i + 1] = p[i + 2] = l; }
        else {
          l = Math.pow(l, 1.25) * 255;
          // gold gets a warm sepia etch, silver a neutral one
          var t2 = l * (255 - l) / 255; p[i] = l; p[i + 1] = warm ? l - t2 * 0.08 : l; p[i + 2] = warm ? l - t2 * 0.25 : l;
        }
      }
      g.putImageData(d, 0, 0);
    } catch (e) {}
    return c;
  }

  // hairline soft edge so the engraving sits in the plate without a visible frame
  function softEdge(c, r) {
    var g = c.getContext('2d'), W = c.width, H = c.height, e = Math.max(1.2, Math.min(W, H) * 0.012);
    g.globalCompositeOperation = 'destination-in';
    var a = g.createLinearGradient(0, 0, W, 0);
    a.addColorStop(0, 'rgba(0,0,0,0)'); a.addColorStop(e / W, 'rgba(0,0,0,1)');
    a.addColorStop(1 - e / W, 'rgba(0,0,0,1)'); a.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = a; g.fillRect(0, 0, W, H);
    var b = g.createLinearGradient(0, 0, 0, H);
    b.addColorStop(0, 'rgba(0,0,0,0)'); b.addColorStop(e / H, 'rgba(0,0,0,1)');
    b.addColorStop(1 - e / H, 'rgba(0,0,0,1)'); b.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = b; g.fillRect(0, 0, W, H);
    g.globalCompositeOperation = 'source-over';
    return c;
  }

  var stripCache = { key: null, c: null };
  function engravingStrip(crop, ZL, ZT, light, warm) {
    var key = crop.__jpcId + '|' + Math.round(ZL) + 'x' + Math.round(ZT) + (light ? 'L' : warm ? 'W' : 'D');
    if (stripCache.key === key) return stripCache.c;
    var c = softEdge(inkify(fillStrip(crop, ZL, ZT), light, warm));
    stripCache = { key: key, c: c };
    return c;
  }

  function draw(cv, crop, v, mat) {
    var key = v && v.m ? String(v.m) : '';
    var cal = CAL[key];
    if (!cal || !v.u) return false;
    var url = v.u;
    var token = (cv.__jpcTok = (cv.__jpcTok || 0) + 1);
    loadImg(url).then(function (im) {
      if (cv.__jpcTok !== token) return;
      var base = cleanBase(key, cal, im);
      if (!base) return;
      var vw = cal.view[2], vh = cal.view[3];
      cv.width = vw; cv.height = vh;
      cv.classList.toggle('is-v', cal.t === 'v');
      cv.classList.add('is-photo');
      var g = cv.getContext('2d');
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.clearRect(0, 0, vw, vh);
      g.drawImage(base, cal.view[0], cal.view[1], vw, vh, 0, 0, vw, vh);
      if (!crop) return;
      g.translate(-cal.view[0], -cal.view[1]);
      var light = mat === 'black', warm = mat === 'gold' || mat === 'rose';
      g.save();
      g.globalCompositeOperation = light ? 'source-over' : 'multiply';
      g.globalAlpha = light ? 1 : 0.97;
      g.imageSmoothingQuality = 'high';
      var I = 2, strip;
      if (cal.t === 'h') {
        var zx = cal.face[0] + I, zy = cal.face[1] + I, zw = cal.face[2] - cal.face[0] - 2 * I, zh = cal.face[3] - cal.face[1] - 2 * I;
        strip = engravingStrip(crop, zw, zh, light, warm);
        g.drawImage(strip, zx, zy, zw, zh);
      } else if (cal.t === 'v') {
        var vx = cal.face[0] + I, vy = cal.face[1] + I, vw2 = cal.face[2] - cal.face[0] - 2 * I, vh2 = cal.face[3] - cal.face[1] - 2 * I;
        strip = engravingStrip(crop, vh2, vw2, light, warm);
        g.translate(vx + vw2, vy); g.rotate(Math.PI / 2);
        g.drawImage(strip, 0, 0, vh2, vw2);
      } else {
        var bx0 = cal.zx[0], bx1 = cal.zx[1];
        var ct = lerpPts(cal.top, cal.zc) + 3, cb = lerpPts(cal.bot, cal.zc) - 2;
        strip = engravingStrip(crop, bx1 - bx0, cb - ct, light, warm);
        var sx = strip.width / (bx1 - bx0);
        for (var i = 0; i < bx1 - bx0; i++) {
          var x = bx0 + i;
          var t = lerpPts(cal.top, x) + 3, b = lerpPts(cal.bot, x) - 2;
          g.drawImage(strip, i * sx, 0, sx, strip.height, x, t, 1, b - t);
        }
      }
      g.restore();
      // jump rings and holes go back on top of the engraving
      var ring = ringCache[key];
      if (ring) { g.save(); g.setTransform(1, 0, 0, 1, 0, 0); g.drawImage(ring, cal.view[0], cal.view[1], vw, vh, 0, 0, vw, vh); g.restore(); }
    }).catch(function () {});
    return true;
  }

  window.jpcrop1Preview = { draw: draw };
})();